import React, { useState } from "react";
import LoginComponent from "Components/Login";
import { Link, NavLink } from "react-router-dom";
import GetQuotationComponent from "Components/GetQuotation";
import { AssestsIcon } from "../../Constants/AssetsConstants";
import Icon from "./CustomIcon";
import DialogComponent from "./dialog";

const HeaderComponent = () => {
  const [loginDialogOpen, setLoginDialogOpen] = useState(false);
  const [getQuotationDialogOpen, setGetQuotationDialogOpen] = useState(false);

  const handleLoginDialog = () => {
    setLoginDialogOpen(!loginDialogOpen);
  };

  const handleGetQuotationDialog = () => {
    setGetQuotationDialogOpen(!getQuotationDialogOpen);
  };

  return (
    <>
      <DialogComponent
        title="Welcome to"
        handleDialogOpen={setLoginDialogOpen}
        dialogOpen={loginDialogOpen}
      >
        <LoginComponent />
      </DialogComponent>
      <DialogComponent
        title="Get Quotation"
        handleDialogOpen={setGetQuotationDialogOpen}
        dialogOpen={getQuotationDialogOpen}
      >
        <GetQuotationComponent />
      </DialogComponent>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark w-100">
        <div className="container-fluid">
          <div>
            <Link to="/" className="navbar-brand d-flex flex-grow-1">
              <div className="d-flex logo-header-container">
                <p className="logo-p">
                  FST
                  <span className="logo-p-details">design deliver empower</span>
                </p>
              </div>
            </Link>
          </div>

          <div className="me-auto mb-2 mb-lg-0" />

          <ul className="navbar-nav">
            <li className="nav-item dropdown">
              <NavLink to="/" className="nav-link" activeClassName="homeActive">
                HOME
              </NavLink>
              <div className="navbar-active-hr" />
            </li>
            {/*<li className="nav-item dropdown">*/}
            {/*  <NavLink to="/" className="nav-link" activeClassName="active">*/}
            {/*    ABOUT*/}
            {/*  </NavLink>*/}
            {/*</li>*/}

            {/*<li className="nav-item dropdown">*/}
            {/*  <NavLink to="/" className="nav-link" activeClassName="active">*/}
            {/*    PROJECT*/}
            {/*  </NavLink>*/}
            {/*</li>*/}
            {/*<li className="nav-item dropdown">*/}
            {/*  <NavLink to="/" className="nav-link" activeClassName="active">*/}
            {/*    CONTACT US*/}
            {/*  </NavLink>*/}
            {/*</li>*/}
            <li className="nav-item dropdown">
              <button className="btn nav-get-quotation-button" onClick={handleGetQuotationDialog}>
                Get Quotation
              </button>
            </li>
            <li className="nav-item dropdown ">
              <button className="btn nav-login-button" onClick={handleLoginDialog}>
                Login
              </button>
            </li>
          </ul>
          <div className="nav-logo">
            <Icon icon={AssestsIcon.ICON_MENU} size={30} />
          </div>
        </div>
      </nav>
    </>
  );
};

export default HeaderComponent;
